// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3f4gB","ranges":"BmiRanges_ranges__Sz4NR"};